module.exports = __webpack_public_path__ + "img/sousuo.8fc2d596.png";